export default {
	expirationCookieName: "py-expires", // cookie the server sets to hold expiration time
	expirationStorageName: "performyardSessionExpiration", // localstorage expiration datetime
	redirectCountdownStorageName: "performyardRedirectCountdown", // localstorage redirect countdown start time
};
